export class RangeSliderValue {
    from: number;
    to: number;
}

export class RangeSliderSlideValue {
    initial: number;
    current: number;
}

export type RangeSliderButtonType = 'from' | 'to';

export const RANGE_SLIDER_MIN_VALUE = 0;

export const RANGE_SLIDER_MAX_VALUE = 100;
